// @ vendors
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const moment = require('moment');
const momentTz = require('moment-timezone');
const get = require('lodash/object/get');
const reduce = require('lodash/collection/reduce');
const trim = require('lodash/string/trim');
const Immutable = require('immutable');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;



// @ actions
const { updateConsents } = require('actions/gdprConsents');
const brokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const { searchSpecificIsin } = require('actions/brokerProductAdvancedSearch');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
    BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER,
    BROKER_EMPLOYEE_ID,
    FIRST_STEP,
    SECOND_STEP,
    BROKER_RED_FUND,
    BROKER_YELLOW_FUND,
    BROKER_GREEN_FUND,
    BROKER_MIFID_FUND_RED,
    BROKER_MIFID_FUND_YELLOW,
    BROKER_MIFID_FUND_GREEN,
    CHARGE_ACCOUNT_PREFIX,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_PRODUCT_TYPE_FUNDS_ES,
    BROKER_ORDER_TYPE_BUY,
    BROKER_MIFID_VERSION_2,
    INTERVENER_TYPE_TITULAR,
    LEGAL_DOCUMENTS_TYPES,
    API_CHANNEL,
    PERIODICITY_DOCUMENT_SERVICE,
} = require('constants/index');
const { ADD_SUSCRIPTION_ERROR, HIRE_INVESTMENT_FUND_ERROR } = require('constants/contactCenter/investmentFundsActionErrorTypes');
const { COUNTRIES_CODES: { DE, PT } } = require('constants/countries');
// @ helpers
const { getControlDigitFromCodBban } = require('utilities/ibanHelper');
const { generateAccountId } = require('utilities/APIParsingHelper');
const  { showMemories } = require( 'commonsUtilities/showMemoriesHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @utils
const PersonalDataHelper = require('utilities/personalDataHelper');
const translateExantCostKey = require('utilities/translationExantCost');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');

const requestInvestmentFundsInProgress = () => ({
    type: actionTypes.FETCH_BROKER_INVESTMENT_FUNDS_REQUEST
});

const requestInvestmentFundsSuccess = (data, response) => ({
    type: actionTypes.FETCH_BROKER_INVESTMENT_FUNDS_SUCCESS,
    payload: {
        investmentFunds: data,
        securityDetails: response
    }
});

const requestInvestmentFundsFailure = (error, errorType = '') => ({
    type: actionTypes.FETCH_BROKER_INVESTMENT_FUNDS_FAILURE,
    payload: {
        error,
        errorType
    }
});


const requestInvestmentAlternativeFundsSuccess = (data) => ({
    type: actionTypes.FETCH_BROKER_INVESTMENT_ALTERNATIVE_FUNDS_SUCCESS,
    payload: {
        investmentAlternativeFund: data.alternativeFunds.instrumentsList[0],
    }
});

const requestInvestmentFundsPreInProgress = () => ({
    type: actionTypes.FETCH_BROKER_INVESTMENT_FUNDS_PRE_REQUEST
});

const requestInvestmentFundsPreFailure = error => ({
    type: actionTypes.FETCH_BROKER_INVESTMENT_FUNDS_PRE_FAILURE,
    payload: {
        error
    }
});

const requestInvestmentFundsNotFound = () => ({
    type: actionTypes.FETCH_BROKER_INVESTMENT_FUNDS_NOT_FOUND,
    payload: {
        error: formatText('brokerHireInvestmentStep1-nonExistingFund')
    }
});

const reset = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_RESET
});

const setAccountNumber = (accountId, accountAmount, linkedToRobo) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_ACCOUNT_NUMBER,
    payload: {
        accountId,
        accountAmount,
        linkedToRobo,
    }
});

const setVisibleStep = step => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillLeave = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_WILL_LEAVE
});

//TODO: Add a confirmation when a user click con Cancel.
const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const subscriptionSuccess = (hiredFunds) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_SUCCESS,
    payload: { hiredFunds }
});

const changeAuth = auth => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_AUTHORIZATION,
    payload: {
        auth
    }
});

const changeReadChecked = checked => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_READCHECKED,
    payload: {
        checked
    }
});

const setAmount = amount => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_AMOUNT,
    payload: {
        amount
    }
});

const addIntervener = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_ADD_INTERVENER
});

const removeIntervener = (index, originalInterveners) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_REMOVE_INTERVENER,
    payload: {
        index,
        originalInterveners
    }
});

const setIntervenerName = (index, name, originalInterveners) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_ACCOUNT_INTERVENER_NAME,
    payload: {
        index,
        name,
        originalInterveners
    }
});

const setIntervenerType = (index, type) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_ACCOUNT_INTERVENER_TYPE,
    payload: {
        index,
        type
    }
});

const restoreDefaultInterveners = originalInterveners => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_RESTORE_DEFAULT_INTERVENERS,
    payload: {
        originalInterveners
    }
});

const postPreHireSuccess = (data, featureFlag) => ({
    type: actionTypes.FETCH_BROKER_PRE_HIRE_SUCCESS,
    payload: {
        data,
        featureFlag
    }
});

const setContract = (contractToChange) => ({
    type:actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_CONTRACT,
    payload: contractToChange
});

const intervenersCountInitial = {
    '01': 0,
    '07': 0,
    '08': 0,
    '09': 0,
    '25': 0
};

const typeCount = inteveners => inteveners.reduce(
    (accumulator, intervener) => {
        accumulator[intervener.get('interventionType')] = accumulator[intervener.get('interventionType')] + 1;
        return accumulator;
    }, intervenersCountInitial
);

const postPreHire = (fundId, isShowExtantCost, history) => (dispatch, getState) => {
    const immInvestmentFunds = getState().investmentFunds;
    const amount = parseFloat(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'amount'])).toFixed(2);
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'accountNumber']));

    if (!immAccount) {
        return;
    }

    const contractNumber = immAccount.get('contractNumber');
    const productNumber = immAccount.get('product');
    const balanceAmount = immAccount.getIn(['balance', 'amount']).toFixed(2);
    const currency = immAccount.getIn(['balance', 'currency']);
    const type = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'type']);
    const subtype = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'subtype']);
    const today = moment().format('YYYY-MM-DD');
    const interveners = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'interveners']);
    const interventionForm = typeCount(interveners);
    const isin = immInvestmentFunds.getIn(['investmentFunds', 'isin']);

    const parsedInterveners = interveners.map(intervener => {
        const interventionType = intervener.get('interventionType');
        const interventionFormValue = interventionForm[interventionType]
        const interventionFormString = interventionFormValue < 10 ? `0${interventionFormValue}` : `${interventionFormValue}`;
        return {
            formaIntervencion: interventionFormString,
            intervencion: interventionType,
            numPersona: intervener.get('personNumber'),
            tipoPersona: intervener.get('personType')
        };
    });

    const cuentaSeleccionada = {
        numerodecontrato: contractNumber,
        producto: productNumber
    };
    const datos = {
        dato: parsedInterveners.toJS()
    };
    const importeDivision = {
        divisa: currency,
        importe: parseFloat(amount)
    };
    const saldoCuentaSeleccionada = {
        divisa: currency,
        importe: parseFloat(balanceAmount)
    };
    const query = {
        cuentaSeleccionada: cuentaSeleccionada,
        datos: datos,
        fechaOrden: today,
        importeDivision: importeDivision,
        numEmpleado: BROKER_EMPLOYEE_ID,
        saldoCuentaSeleccionada: saldoCuentaSeleccionada,
        subtipo: subtype,
        tipo: type
    }

    const requestData = {
        query: query
    };

    const requestExtantCost = {
        header: {
            version: 2
        },
        query: {
            ...query,
            isin: isin,
        }
    };

    const request = isShowExtantCost ? requestExtantCost : requestData;
    dispatch(requestInvestmentFundsPreInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerPreHireInvestmentFund'), request)
        .then(response => dispatch(postPreHireSuccess(response, isShowExtantCost)), function(response) {
            dispatch(requestInvestmentFundsPreFailure(response.error));
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        })
        .catch(response => dispatch(requestInvestmentFundsPreFailure(response.error)));
};

const validateStep = step => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_VALIDATE_STEP,
    payload: {
        step
    }
});

const getAccountSuccess = data => ({
    type: actionTypes.FETCH_BROKER_GET_ACCOUNTS_HIRE_SUCCESS,
    payload: {
        data
    }
});

const getIntervenersSuccess = data => ({
    type: actionTypes.FETCH_BROKER_GET_INTERVENERS_SUCCESS,
    payload: {
        data
    }
});

const getIntervenersContractSuccess = data => ({
    type: actionTypes.FETCH_BROKER_GET_INTERVENERS_CONTRACT_SUCCESS,
    payload: {
        data
    }
});

const postHireSuccess = (data) => ({
    type: actionTypes.FETCH_BROKER_HIRE_SUCCESS,
    payload: {
        data
    }
});

const requestExtantCostsBuyFundsProgress = () => ({
    type: actionTypes.BROKER_EXTANT_COST_FETCH_FETCHING
});

const requestExtantCostsBuyFundsSuccess = (response) => ({
    type: actionTypes.BROKER_EXTANT_COST_FETCH_SUCCESS,
    payload: response
});

const requestExtantCostsBuyFundsFailure = (error, errorType = '') => ({
    type: actionTypes.BROKER_EXTANT_COST_FETCH_FAILURE,
    payload: {
        error,
        errorType
    }
});

const postExtantCostsBuyFunds = (query, history) => (dispatch) => {
    const requestData = {
        header: {
            version: 2
        },
        query: query
    };
    dispatch(requestExtantCostsBuyFundsProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerBuyFundsExtantCosts'), requestData)
        .then(response => dispatch(requestExtantCostsBuyFundsSuccess(response)))
        .catch(response => {
            dispatch(requestExtantCostsBuyFundsFailure(response.error)); dispatch(errorActions.show('', true, history));
        });

}

const getAccounts = (dispatch, getState) => {
    const investmentFunds = getState().investmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds']);
    const type = investmentFunds.get('type');
    const subtype = investmentFunds.get('subtype');
    const reference = investmentFunds.get('reference');
    const requestData = {
        header: {
            version: 2
        },
        query: {
            pais: 'ES', // @hardcoded
            referencia: reference,
            segmento: 'PA', // @hardcoded
            subtipo: subtype,
            tipo: type
        }
    };

    dispatch(requestInvestmentFundsInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetAccountsInvestment'), requestData)
        .then(response => dispatch(getAccountSuccess(response)))
        .catch(response => dispatch(requestInvestmentFundsFailure(response.error)));
};

const getAccountsAlternativeFunds = (dispatch, getState) => {
    const investmentFunds = getState().investmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds']);
    const immFund = getState().investmentFunds.get('investmentFunds');
    const amount = investmentFunds.getIn(['minInvestment','amount'])
    const currency = investmentFunds.getIn(['minInvestment','currency'])
    const additionalSubscriptionAmount = immFund.get('additionalSubscriptionAmount')
    const adaptResponse = (response)=> {
        return {
            minimumPurchase : {
                amount,
                currency,
                additionalSubscriptionAmount
            },
            listaCuentasCorrientes: response.datos
        }
    }

    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetAccountsAlternativeInvestment'))
        .then(response => dispatch(getAccountSuccess(adaptResponse(response))))
        .catch(response => dispatch(requestInvestmentFundsFailure(response.error)));
};

const getInterveners = accountNumber => (dispatch, getState) => {
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(accountNumber);
    const contractNumber = immAccount.get('contractNumber');
    const productNumber = immAccount.get('product');

    const requestData = {
        query: {
            producto: productNumber,
            numeroContrato: contractNumber
        }
    };

    dispatch(requestInvestmentFundsInProgress());

    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetIntervenersInvestment'), requestData)
        .then(response => dispatch(getIntervenersSuccess(response)))
        .catch(response => dispatch(requestInvestmentFundsFailure(response.error)));
};

const clearAllContractInterveners = () => ({
    type: actionTypes.BROKER_CLEAR_ALL_FUNDS_CONTRACT_INTERVENERS
})

const requestAllContractsIntervenersSuccess = data => ({
    type: actionTypes.FETCH_BROKER_GET_ALL_FUND_CONTRACT_INTERVENERS_SUCCESS,
    payload: {
        data
    }
})

const getIntervenersFromAllContracts = accountId => (dispatch, getState) => {
    if(accountId){
        const accountSelectedContractNumber = getState().accounts.getIn(['byId', accountId, 'contractNumber']);
        const immInvestmentFunds = getState().investmentFunds;
        const kindOfFund = immInvestmentFunds.get('isAlternativeFund') ? 'alternativeFunds' : 'funds';
        const immBrokerMyInvestments = getState().brokerMyInvestments;
        const selectedFundIsin = immInvestmentFunds.getIn(['investmentFunds', 'isin']);
        const immFunds = immBrokerMyInvestments.getIn(['products', kindOfFund, 'stocks'])
            .filter(immFund =>
                immFund.get('associatedAccountContractNumber') === accountSelectedContractNumber &&
                immFund.get('isin') === selectedFundIsin
            );
        if(!immFunds.isEmpty()){
            const promises = immFunds.map(fund => {
                const requestData = {
                    query: {
                        producto: fund.get('producto'),
                        numeroContrato: fund.get('contractNumber')
                    }
                };
                return APIGet(dispatch, apiURLBuilder.getURL('brokerIntervenersFunds'), requestData);
            });
            dispatch(requestInvestmentFundsInProgress());
            return Promise.all(promises.toJS())
                .then(response => {
                    let fundsIntervinients = {};
                    immFunds.toArray().forEach((immFund, index) => {
                        fundsIntervinients[immFund.get('contractNumber')] = response[index]
                    });
                    dispatch(requestAllContractsIntervenersSuccess(fundsIntervinients));
                    /* dispatch(setUniqueFuncContract(accountId)); */
                })
                .catch(response => dispatch(requestInvestmentFundsFailure(response.error)))
        }else{
            dispatch(clearAllContractInterveners())
        }
    }
}

const setIsValidSchema = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_IS_VALID_SCHEMA
});

const setIsInvalidSchema = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_IS_INVALID_SCHEMA
});

const validateSchema = isValid => (dispatch) => {
    if(isValid){
        dispatch(setIsValidSchema());
    }else{
        dispatch(setIsInvalidSchema());
    }
}

const getIntervenersContractByContractNumber = contractNumber => (dispatch, getState) => {
    const immInvestmentFunds = getState().investmentFunds;
    const kindOfFund = immInvestmentFunds.get('isAlternativeFund') ? 'alternativeFunds' : 'funds';
    const immFunds = getState().brokerMyInvestments.getIn(['products', kindOfFund, 'stocks']);
    const immFund = immFunds.find(fund => fund.get('contractNumber') === contractNumber);
    const producto = immFund.get('producto')
    const requestData = {
        query: {
            producto: producto,
            numeroContrato: contractNumber
        }
    };

    dispatch(requestInvestmentFundsInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerIntervenersFunds'), requestData)
        .then(response => dispatch(getIntervenersContractSuccess(response)))
        .catch(response => dispatch(requestInvestmentFundsFailure(response.error)));
}

const getIntervenersContract = fundId => (dispatch, getState) => {
    const immInvest = getState().investmentFunds;
    const kindOfFund = immInvest.get('isAlternativeFund') ? 'alternativeFunds' : 'funds';
    const immInvestmentFunds = getState().brokerMyInvestments.getIn(['products', kindOfFund, 'stocks']);
    const immFund = immInvestmentFunds.find(fund => fund.get('id') === fundId);
    const producto = immFund.get('producto')
    const numerodecontrato = immFund.get('numerodecontrato')
    const requestData = {
        query: {
            producto: producto,
            numeroContrato: numerodecontrato
        }
    };

    dispatch(requestInvestmentFundsInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerIntervenersFunds'), requestData)
        .then(response => dispatch(getIntervenersContractSuccess(response)))
        .catch(response => dispatch(requestInvestmentFundsFailure(response.error)));
};

function investmentFundsDocumentStorageRequest(){
    return {
        type: actionTypes.INVESTMENT_FUND_DOCUMENT_STORAGE_REQUEST
    }
}

function investmentFundsDocumentStorageSuccess() {
    return {
        type: actionTypes.INVESTMENT_FUND_DOCUMENT_STORAGE_SUCCESS
    };
}

function investmentFundsDocumentStorageError() {
    return {
        type: actionTypes.INVESTMENT_FUND_DOCUMENT_STORAGE_ERROR
    };
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map((immDisclaimer, index) => {
        const disclaimer = index === 0 && immDisclaimer.get('phrase')
        ? `${immDisclaimer.get('description')} ${immDisclaimer.get('phrase')}`
        : immDisclaimer.get('description')
        return disclaimer
    }).join(' | ');
};

const getHolders = (interveners) => {
    let holderNames = [];
    holderNames = interveners.filter((intervener) => {
        return intervener.get('type').trim() === INTERVENER_TYPE_TITULAR
    }).map(holder => {
        return holder.get('name').trim()
    });
    return holderNames;
}

const storeDocument = (orderResponse, isAlternativeFund, isContribution=false) => (dispatch, getState) => {
    let communicationServiceInput, data;
    const { INFORME_SEMESTRAL, DFI, RISKS, RECOMMENDATIONS, PROSPECTUS } = LEGAL_DOCUMENTS_TYPES;
    const immBrokerFundLegalDocument =  getState().brokerFundLegalDocument;
    const immBrokerMyInvestments = getState().brokerMyInvestments;
    const immProfile = getState().profile;
    const alternativeFundsDocs = immBrokerFundLegalDocument.get('alternativeFundsDocs');
    const originCountry = immProfile.get('originCountry');
    const immInvestmentFunds = getState().investmentFunds;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const amount = parseFloat(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'amount']));
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'accountNumber']));
    const controlDigit = trim(immAccount.getIn(['ibanComplex', 'digitodecontrol']));
    const contractNumber = trim(immAccount.get('contractNumber'));
    const productNumber = trim(immAccount.get('product'));
    const fundControlDigit = trim(immInvestmentFunds.getIn(['contractFund', 'controlDigit']));
    const fundContractNumber = trim(immInvestmentFunds.getIn(['contractFund', 'contractNumber']));
    const fundProductNumber = trim(immInvestmentFunds.getIn(['contractFund', 'product']));
    const currency = immAccount.getIn(['balance', 'currency']);
    const isin =immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
    const emittedDateTime = momentTz(parseInt(get(orderResponse, 'timestamp', ''), 10)).tz("Europe/Madrid");
    const fundName =immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'name']);
    const interveners = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'interveners']);
    const ffShowExantCost = immFlagBasedFeatures.get('wealth_funds_buy_show_costs');
    const holderNames = getHolders(interveners);
    const recommendationReport = alternativeFundsDocs.getIn([RECOMMENDATIONS, 'originURL' ]);
    const riskAssumptionDocument = alternativeFundsDocs.getIn([RISKS, 'originURL' ]);
    const prospectusReport = alternativeFundsDocs.getIn([PROSPECTUS, 'originURL' ]);
    const productKidDocumentUrl = !isAlternativeFund ? immBrokerFundLegalDocument.get('fundamentalDataForInvesorUrl') : alternativeFundsDocs.getIn([DFI, 'originURL' ]);
    let marketingReportUrl = ''
    if (immProfile.get('originCountry').toUpperCase() !== DE) {
        marketingReportUrl = immBrokerFundLegalDocument.get('marketingReportsUrl');
    }
    const commercialReport = alternativeFundsDocs.getIn([INFORME_SEMESTRAL, 'originURL' ]);
    const economicReportUrl = immBrokerFundLegalDocument.get('lastPublishedEconomicReportUrl')
    const immFundTransactionCostDocument = immBrokerFundLegalDocument.getIn(['fundTransactionCostDocument', isin]);
    const costYieldObjectId = immFundTransactionCostDocument ? immFundTransactionCostDocument.get('objectId') : '';
    const cantidadParticipaciones = get(orderResponse, ['cantidadParticipaciones'], '');
    const associatedAccount = trim(
        CHARGE_ACCOUNT_PREFIX +
        controlDigit +
        productNumber +
        contractNumber
    );
    const fundCcv = trim(
        CHARGE_ACCOUNT_PREFIX +
        fundControlDigit +
        fundProductNumber +
        fundContractNumber
    );

    communicationServiceInput = {
        "email":PersonalDataHelper.getEmail(immProfile),
        "productKID": productKidDocumentUrl,
        "contract": "",
        "marketingReport": marketingReportUrl,
        "economicReport": economicReportUrl,
        "sendOrder": "No",
        "clientAlias": immProfile.get('nombreCliente'),
        "isin": isin,
        "isinDescribe": fundName,
        "idOrder" : '',
        "channel" : CONNECTION_CHANNEL_INTERNET,
        "orderType" : BROKER_ORDER_TYPE_BUY,
        "productType" : BROKER_PRODUCT_TYPE_FUNDS_ES,
        "holders" : holderNames.join(','),
        "ccv" : fundCcv,
        "idContract": fundCcv,
        "ccc": associatedAccount,
        "market": '',
        "sharesNumber": cantidadParticipaciones,
        "orderCondition": getState().brokerProductFile.descripcionOrden,
        "sharesAmount":"" + amount,
        "termValidity": "",
        "conditionPrize": "",
        "currency": currency,
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        "dateTime" : emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME)
    };

    const ffContribution = immFlagBasedFeatures.get('wealth_funds_periodic_contributions');
    const immHirePeriodicContribution = getState().investmentFundsWithContribution;
    const isSubscription = immInvestmentFunds.getIn(['steps', 0 ,'isSubscription'], false);
    const skipContribution = immHirePeriodicContribution.get('skipContribution');

    if (isContribution && ffContribution && !isSubscription && !isAlternativeFund && !skipContribution) {
        const periodicity = immHirePeriodicContribution.getIn(['steps', 1, 'periodicityValue']);
        const contributionAmount = immHirePeriodicContribution.getIn(['steps', 1, 'amount']);
        communicationServiceInput = {
            ...communicationServiceInput,
            "periodicContribution": {
                "amount": contributionAmount,
                "contributionOrderType": "ALTA DE COMPRA PERIÓDICA",
                "date":  emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME),
                "periodicity": PERIODICITY_DOCUMENT_SERVICE[periodicity],
            }
        }
    }

    if (ffShowExantCost) {
        const exAnteCostsList = ffContribution && !isSubscription && !isAlternativeFund
            ? immHirePeriodicContribution.getIn(['fetchDataExt', 'response'])
            : immInvestmentFunds.getIn(['fetchDataExt', 'response']);
        communicationServiceInput = {
            ...communicationServiceInput,
            "exAnteCostsList":  translateExantCostKey(exAnteCostsList.toJS(), "brokerHireInvestmentStep2"),
        };
    }else {
        communicationServiceInput = {
            ...communicationServiceInput,
            "costYield": costYieldObjectId,
        };
    }

    if (originCountry === PT) {
        const prospectusReportLink = apiURLBuilder.getURL('morningstarFundDocumentPDF', {
            isin: isin,
            documentType: 'Prospectus',
            originCountry: originCountry,
        });

        const anualReportLink = apiURLBuilder.getURL('morningstarFundDocumentPDF', {
            isin: isin,
            documentType: 'Anual',
            originCountry: originCountry,
        });

        communicationServiceInput = {
            ...communicationServiceInput,
            prospectus: prospectusReportLink,
            annualEconomicReport: anualReportLink,
        };

    }

    if (isAlternativeFund) {
        communicationServiceInput = {
            ...communicationServiceInput,
            recommendationReport: recommendationReport,
            riskAssumptionDocument: riskAssumptionDocument,
            prospectus: prospectusReport,
            commercialReport: commercialReport,
            isPrivateEquity: true

        };
    }

    data = {
        query: communicationServiceInput,
    };


    const dataRequest = { url: "communication", request: data };
    dispatch(investmentFundsDocumentStorageRequest());
    return APIPost(dispatch, apiURLBuilder.getURL(dataRequest.url), dataRequest.request).then(
        function () {
            dispatch(investmentFundsDocumentStorageSuccess());
        },
        function () {
            dispatch(investmentFundsDocumentStorageError());
        }
    );
}

const findFundMiFIDID = (fundType) => {
    let fundMifidId;
    switch (fundType) {
        case BROKER_RED_FUND:
            fundMifidId = BROKER_MIFID_FUND_RED;
            break;
        case BROKER_YELLOW_FUND:
            fundMifidId = BROKER_MIFID_FUND_YELLOW;
            break;
        case BROKER_GREEN_FUND:
            fundMifidId = BROKER_MIFID_FUND_GREEN;
            break;
    }
    return fundMifidId;
}

const mifidDisclaimersResponse = (immBrokerConvenienceMiFIDTest) => {
    const isUsingMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_2;
    let disclaimers = undefined;

    if (isUsingMifidv2) {
        const mifidv2AllDisclaimers =
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers'])
            .merge(immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']))
            .toJS();

        disclaimers = reduce(mifidv2AllDisclaimers, (result, disclaimer, index) => {
            const disclaimerKey = `disclaimer_${index + 1}`;
            let disclaimerText;
            if (index === 0 && !!get(disclaimer, 'phrase')){
                disclaimerText = `${trim(get(disclaimer, 'description'))} ${get(disclaimer, 'phrase')}`
            } else{
                disclaimerText = trim(get(disclaimer, 'description'));
            }

            result[disclaimerKey] = `${trim(get(disclaimer, 'id'))} | ${disclaimerText}`;

            return result;
        }, {});
    }

    return disclaimers;
};

const postHireInvestment = (dispatch, getState, dataToken, history, isAlternativeFund) => {
    const immInvestmentFunds = getState().investmentFunds;
    const amount = parseFloat(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'amount']));
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'accountNumber']));
    const contractNumber = immAccount.get('contractNumber');
    const productNumber = immAccount.get('product');
    const currency = immAccount.getIn(['balance', 'currency']);
    const subtype = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'subtype']);
    const fundContractNumber = immInvestmentFunds.getIn(['contractFund', 'contractNumber']);
    const fundProductNumber = immInvestmentFunds.getIn(['contractFund', 'product']);
    const fundName = immInvestmentFunds.getIn(['steps', SECOND_STEP, 'preContract', 'fundName']);
    const today = moment().format('YYYY-MM-DD');
    const fundManager = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'manager']);
    const unitPrice = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'netAssetValue', 'amount']);
    const fundType = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'customCategoryId3']);
    const FundMiFID = findFundMiFIDID(fundType);
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', FundMiFID, 'codigoDisclaimer']);
    const isinCode = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
    const newContractNumber = immAccount.get('newContractNumber');
    const newProductNumber = immAccount.get('newProduct');

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const ffContribution = immFlagBasedFeatures.get('wealth_funds_periodic_contributions');

    const isSubscription = immInvestmentFunds.getIn(['steps', 0 ,'isSubscription'], false);

    let recurringTransfer;
    if(ffContribution &&  !isSubscription && !isAlternativeFund) {
        const immHirePeriodicContribution = getState().investmentFundsWithContribution;
        const periodicity = immHirePeriodicContribution.getIn(['steps', 1, 'periodicityValue']);
        const selectedDate = immHirePeriodicContribution.getIn(['steps', 1, 'selectedDate']);
        const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
        const contributionAmount = immHirePeriodicContribution.getIn(['steps', 1, 'amount']);
        recurringTransfer = {
            recurringTransfer: {
                amount: contributionAmount,
                channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
                contractCode: fundContractNumber,
                currencyCode: currency,
                dataToken: dataToken,
                periodicity: periodicity,
                productId: fundProductNumber,
                subscriptionDate: formattedDate,
            }
        }
    }

    const getAlternativeDisclaimers = () => {
        const mifidAlternativeDisclaimers =  immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']).toJS()
        const suscription = immInvestmentFunds.getIn(['investmentFunds', 'suscription']).toLowerCase();
        const hireDiscalimers = [{
            id: null,
            phrase: null,
            description:
                    `${formatText('brokerAlternativeFundsBuyStep1-informationDisclaimerTitle')}
                    ${formatText('brokerAlternativeFundsBuyStep1-informationDisclaimer', [suscription, suscription])}`,
          }];
        const allDisclaimers = [...mifidAlternativeDisclaimers,...hireDiscalimers];
        const disclaimers = reduce(allDisclaimers, (result, disclaimer, index) => {
            const disclaimerKey = `disclaimer_${index + 1}`;
            result[disclaimerKey] = trim(get(disclaimer, 'description'));
            return result;
          }, {})
        return disclaimers
    };

    const requestData = {
        header: {
            version: 2
        },
        query: {
            contratoFondo: {
                producto: fundProductNumber,
                numerodecontrato: fundContractNumber
            },
            cuentaAsociada: {
                producto: productNumber,
                numerodecontrato: contractNumber
            },
            dataToken,
            fechaOrden: today,
            importeInversion: {
                divisa: currency,
                importe: parseFloat(amount)
            },
            nombreFondo: fundName,
            subtipo: subtype,
            convenienceTest: codigoDisclaimer,
            productIsin: isinCode,
            productManager: fundManager,
            unitPrice: unitPrice,
            initQuantity: '',
            micCode: "",
            convenientRegistry: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
            evaluateRegistry: mifidWasApplied,
            disclaimers: isAlternativeFund
                        ? getAlternativeDisclaimers()
                        : mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
            marketTargetRegistry: mifidScore >= mifidScoring,
            necessaryConvenienceTestNote: mifidScoring,
            necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
            testConveniencyResult: mifidScore,
            newContractNumber,
            newProductNumber,
            uuid: immBrokerLegalDocumentation.get('uuid'),
           ...( ffContribution) && {...recurringTransfer}
        }
    };

    dispatch(requestInvestmentFundsInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerHireInvestmentFund'), requestData)
        .then(
            response => {
                dispatch(postHireSuccess(response));
                dispatch(storeDocument(response, isAlternativeFund, !!recurringTransfer));
                dispatch(outdateGlobalPosition());
                dispatch(outdateMyInvestments());
            },
            function(response) {
                dispatch(requestInvestmentFundsFailure(response.error, __CONTACT_CENTER__ && HIRE_INVESTMENT_FUND_ERROR));
                const errorKey = get(response, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        )
        .catch(response => dispatch(requestInvestmentFundsFailure(response.error, __CONTACT_CENTER__ && HIRE_INVESTMENT_FUND_ERROR)));
};

const hireInvestment = (history, isAlternativeFund) => (dispatch, getState) => {
   const callback = (dispatch, getState, dataToken) => {
        dispatch(updateConsents(dataToken))
            .then(() => postHireInvestment(dispatch, getState, dataToken, history, isAlternativeFund))
            .catch(() => postHireInvestment(dispatch, getState, dataToken, history, isAlternativeFund));
    };
    const isAlreadyFetching = getState().investmentFunds.get('isFetching');

    if (!isAlreadyFetching) {
        new Promise(function() {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback);
        });
    }
};

const postAddSubscriptionDetailsSuccess = (data, contract, account, fundControlDigit) => ({
    type: actionTypes.FETCH_BROKER_ADD_SUBSCRIPTION_DETAILS,
    payload: {
        data,
        contract,
        account: {
            amount: account.getIn(['balances', 'availableBalance','amount']),
            currency: account.getIn(['balance', 'currency'])
        },
        fundControlDigit
    }
});

const getSubscriptionDetails = (fundId) => (dispatch, getState) => {
    const immInvestment = getState().investmentFunds;
    const kindOfFund = immInvestment.get('isAlternativeFund') ? 'alternativeFunds' : 'funds';
    const immInvestmentFunds = getState().brokerMyInvestments.getIn(['products', kindOfFund, 'stocks']);
    const immFund = immInvestmentFunds.find(fund => fund.get('id') === fundId);
    const fundControlDigit = immFund.get('controlDigit');
    const contract = getState().brokerWallets
        .get('fundsList')
        .find(fund =>
            fund.getIn(['contrato', 'producto']) === immFund.get('product') &&
            fund.getIn(['contrato', 'numerodecontrato']) === immFund.get('numerodecontrato')
        );
    const requestData = {
        query: {
            numeroContrato: immFund.get('numerodecontrato'),
            producto: immFund.get('product')
        }
    };
    dispatch(requestInvestmentFundsInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerAddSubscriptionDetails'), requestData)
        .then(response => {
            const iban = {
                country: response.cuentaDomi.pais,
                controlDigit: response.cuentaDomi.digitodecontrol,
                codbban: response.cuentaDomi.codbban
            };
            const accountId = generateAccountId(iban);
            const account = getState().accounts.getIn(['byId', accountId]);

            return dispatch(postAddSubscriptionDetailsSuccess(response, contract, account, fundControlDigit));
        })
        .catch(response => dispatch(requestInvestmentFundsFailure(response.error)));
};

const postAddSubscription = (dispatch, getState, dataToken, history, isAlternativeFund) => {
    const immInvestmentFunds = getState().investmentFunds;
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');
    const currency = immInvestmentFunds.getIn(['subscriptionFund', 'currency']);
    const country = immInvestmentFunds.getIn(['subscriptionFund', 'account', 'country']);
    const codbban = immInvestmentFunds.getIn(['subscriptionFund', 'account', 'codbban']);
    const controlDigit = getControlDigitFromCodBban(codbban);
    const liquidDate = immInvestmentFunds.getIn(['subscriptionFund', 'liquidDate']);
    const amount = immInvestmentFunds.getIn(['subscriptionFund', 'liquidAmount', 'amount']);
    const liquidCurrency = immInvestmentFunds.getIn([
        'subscriptionFund',
        'liquidAmount',
        'currency'
    ]);
    const contractNumber = immInvestmentFunds.getIn(['contractFund', 'contractNumber']);
    const product = immInvestmentFunds.getIn(['contractFund', 'product']);
    const inputAmount = parseFloat(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'amount'])).toFixed(2);
    const fundManager = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'manager']);
    const fundType = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'customCategoryId3']);
    const FundMiFID = findFundMiFIDID(fundType);
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', FundMiFID, 'codigoDisclaimer']);
    const unitPrice = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'netAssetValue', 'amount']);
    const isinCode = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const ffContribution = immFlagBasedFeatures.get('wealth_funds_periodic_contributions');
    let recurringTransfer;
    const isSubscription = immInvestmentFunds.getIn(['steps', 0 ,'isSubscription'], false);
    const immHirePeriodicContribution = getState().investmentFundsWithContribution;
    const skipContribution = immHirePeriodicContribution.get('skipContribution')

    if(ffContribution && !isSubscription && !isAlternativeFund && !skipContribution) {
        const periodicity = immHirePeriodicContribution.getIn(['steps', 1, 'periodicityValue']);
        const selectedDate = immHirePeriodicContribution.getIn(['steps', 1, 'selectedDate']);
        const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
        const contributionAmount = immHirePeriodicContribution.getIn(['steps', 1, 'amount']);
        recurringTransfer = {
            recurringTransfer: {
                amount: contributionAmount,
                channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
                contractCode: contractNumber,
                currencyCode: currency,
                dataToken: dataToken,
                periodicity: periodicity,
                productId: product,
                subscriptionDate: formattedDate,
            }
        }
    }

    const requestData = {
        header: {
            version: 2
        },
        query: {
            codIdioma: 'E', // @hardcoded
            codMonCuenta: currency,
            contrato: {
                numerodecontrato: contractNumber,
                producto: product
            },
            cuentaDomi: {
                codbban: codbban,
                digitodecontrol: controlDigit,
                pais: country
            },
            dataToken,
            fechValorLiq: liquidDate,
            importMov: inputAmount,
            modOP: 'I', // @hardcoded
            valorLiquid: {
                divisa: liquidCurrency,
                valorliquidativo: amount
            },
            convenienceTest: codigoDisclaimer,
            initQuantity: amount / parseFloat(unitPrice),
            productIsin: isinCode,
            productManager: fundManager,
            unitPrice: unitPrice,
            micCode: "",
            convenientRegistry: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
            evaluateRegistry: mifidWasApplied,
            disclaimers: mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
            marketTargetRegistry: mifidScore >= mifidScoring,
            necessaryConvenienceTestNote: mifidScoring,
            necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
            testConveniencyResult: mifidScore,
            documentationId: uuid,
            ...(ffContribution && !isSubscription && !isAlternativeFund) && {...recurringTransfer}
        }
    };

    dispatch(requestInvestmentFundsInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerAddSubscription'), requestData)
        .then(
            response => {
                const immHiredFunds = getState().brokerMyInvestments.getIn([
                    'products',
                    'funds',
                    'stocks'
                ]);

                dispatch(subscriptionSuccess(immHiredFunds.toJS()));
                dispatch(storeDocument(response, isAlternativeFund, true));
                dispatch(outdateGlobalPosition());
                dispatch(outdateMyInvestments());
            },
            function(response) {
                dispatch(requestInvestmentFundsFailure(response.error, __CONTACT_CENTER__ && ADD_SUSCRIPTION_ERROR));
                const errorKey = get(response, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        )
        .catch(response => dispatch(requestInvestmentFundsFailure(response.error, __CONTACT_CENTER__ && ADD_SUSCRIPTION_ERROR)));
};

const addSubscription = (history, isAlternativeFund=false) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        postAddSubscription(dispatch, getState, dataToken, history, isAlternativeFund);
    };
    const isAlreadyFetching = getState().investmentFunds.get('isFetching');

    if (!isAlreadyFetching) {
        new Promise(function() {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback);
        });
    }
};

const setIsSubscription = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_IS_SUBSCRIPTION
});

/**
 * @param {Immutable.Map} immAccount
 * @param {Immutable.List} immPurchasedFunds
 * @param {string} fundIsin
 * @returns {Immutable.Map|undefined}
 */
const findFundPurchasedWithAccount = (immAccount, immPurchasedFunds, fundId) => {
    if (immAccount && immPurchasedFunds && fundId) {
        const immFundFromFundId = immPurchasedFunds.find((immFund) => immFund.get('id') === fundId);

        return immFundFromFundId
    }
};

const updateOperationToSubscription = (immFundPurchasedWithSelectedAccount) => (dispatch) => {
    if (immFundPurchasedWithSelectedAccount) {
        const purchasedFundId = immFundPurchasedWithSelectedAccount.get('id');
        dispatch(setIsSubscription());
        dispatch(getSubscriptionDetails(purchasedFundId));
    }
};

const updateOperationToInitialPurchase = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_IS_NOT_SUBSCRIPTION
});

const updateOperationToNewContract = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CREATE_NEW_CONTRACT
});

const updateOperationType = (selectedAccountId, fundId) => (dispatch, getState) => {
    const immSelectedAccount = getState().accounts.getIn(['byId', selectedAccountId]);
    const immInvestmentFunds = getState().investmentFunds;
    const kindOfFund = immInvestmentFunds.get('isAlternativeFund') ? 'alternativeFunds' : 'funds';
    const immPurchasedFunds = getState().brokerMyInvestments.getIn(['products', kindOfFund, 'stocks']);
    const immPurchasedFundWithSelectedAccount = findFundPurchasedWithAccount(
        immSelectedAccount,
        immPurchasedFunds,
        fundId
    );

    const hasSelectedAccountAlreadyPurchasedFund = immPurchasedFundWithSelectedAccount != null;

    if (hasSelectedAccountAlreadyPurchasedFund) {
        dispatch(updateOperationToSubscription(immPurchasedFundWithSelectedAccount));
    } else {
        dispatch(updateOperationToInitialPurchase());
    }
};



const changeToNewContract = () => (dispatch) => {
    dispatch(updateOperationToNewContract());
};

const changeToSubscription = (fundId) => (dispatch) => {
    dispatch(setIsSubscription());
    dispatch(getSubscriptionDetails(fundId));
}

const clearContract = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CLEAR_FUND_CONTRACT //falta implementar
})

const changeSelectedAccount = (accountId, accountAmount) => (dispatch) => {
    if (accountId) {

        dispatch(setAccountNumber(accountId, accountAmount));
        dispatch(getInterveners(accountId));
        dispatch(getIntervenersFromAllContracts(accountId));
        dispatch(clearContract());
    }
};

const preSelectChangeSelectedAccount = (accountId, accountAmount, fundId) => (dispatch) => {
    if (accountId) {
        dispatch(setAccountNumber(accountId, accountAmount));
        dispatch(updateOperationType(accountId, fundId));
        dispatch(getIntervenersContract(fundId));
        dispatch(getInterveners(accountId));
        dispatch(getIntervenersFromAllContracts(accountId));
    }
};

const getMorningStarScreenerSecurityDetails = (data) => (dispatch, getState) => {
    const typeId = BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER;

    const requestData = {
            query: {
                viewId: 'price',
                LanguageId: 'es-ES',
                responseViewFormat: 'json'
            }
    }
    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarScreenerSecurityDetails', {type:typeId, id:data.rows[0].SecId}), requestData)
        .then(response => dispatch(requestInvestmentFundsSuccess(data, response)))
        .then(() => getAccounts(dispatch, getState))
        .then(() => {
            const immInvestmentFunds = getState().investmentFunds;
            const isinCode = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
            dispatch(searchSpecificIsin(isinCode));
        })
        .catch(response => dispatch(requestInvestmentFundsFailure(response.error)))
};

const getMorningStarScreener = product => (dispatch, getState) => {
    const immInvestmentFunds = getState().investmentFunds;
    const isFetching = immInvestmentFunds.get('isFetching');
    const alreadyFetchedId = immInvestmentFunds.getIn([
        'steps',
        FIRST_STEP,
        'investmentFunds',
        'customInstitutionSecurityId'
    ]);
    const alreadyFetched = immInvestmentFunds.get('fetchSuccess') && alreadyFetchedId === product;

    if (!isFetching && !alreadyFetched) {
        const typeId = BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER;

        const requestData = {
            query: {
                securityDataPoints:
                    'AdministratorCompanyName|SecId|ISIN|Name|CustomCategoryIdName|CustomMinimumPurchaseAmount|CustomMinimumPurchaseAmountUnit|CustomMinimumAdditionalPurchaseAmount|CustomMinimumAdditionalPurchaseAmountUnit|CustomInstitutionSecurityId|ReturnM0|CustomCategoryId3',
                pageSize: 5000,
                outputType: 'json',
                languageId: 'es-ES',
                currencyId: 'EUR',
                universeIds: 'FOEUR$$ALL_2118',
                filters: `CustomInstitutionSecurityId:EQ:${product}`
            }
        };

        dispatch(requestInvestmentFundsInProgress());
        return APIGet(
            dispatch,
            apiURLBuilder.getURL('brokerGetMorningStarScreener', { type: typeId }),
            requestData
        )
            .then(response => {
                if (!!response.rows.length) {
                    return dispatch(getMorningStarScreenerSecurityDetails(response));
                } else {
                    return dispatch(requestInvestmentFundsNotFound());
                }
            })
            .catch(response => dispatch(requestInvestmentFundsFailure(response.error)));
    }
};

const clearFetchedPre = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CLEAR_FETCHED_PRE
});

const resetFetchedPre = () => dispatch => {
    dispatch(clearFetchedPre);
};

/**
 * @param {Immutable.Map|Immutable.List} immAccounts
 * @param {Immutable.List} immPurchasedFunds
 * @param {string} fundId
 * @returns {Immutable.Map|undefined}
 */
const getAccountOwningFundFromFundId = (immAccounts, immPurchasedFunds, fundId) => {
    if (immAccounts && immPurchasedFunds && fundId) {
        const immFundFromFundId = immPurchasedFunds.find((immFund) => immFund.get('id') === fundId);

        if (immFundFromFundId) {
            const fundAssociatedAccount = immFundFromFundId.get('associatedAccountContractNumber');
            return immAccounts.find((immAccount) => immAccount.get('contractNumber') === fundAssociatedAccount);
        }
    }
};

const preSelectAccountOwningFund = (fundId) => (dispatch, getState) => {
    const immAccounts = getState().accounts.get('byId');
    const immInvestmentFunds = getState().investmentFunds;
    const kindOfFund = immInvestmentFunds.get('isAlternativeFund') ? 'alternativeFunds' : 'funds';
    const immPurchasedFunds = getState().brokerMyInvestments.getIn(['products', kindOfFund, 'stocks']);
    const immAccountOwningFundToPreSelect = getAccountOwningFundFromFundId(
        immAccounts,
        immPurchasedFunds,
        fundId
    );

    if (immAccountOwningFundToPreSelect) {
        const accountId = immAccountOwningFundToPreSelect.get('accountId');
        const accountBalance = immAccountOwningFundToPreSelect.getIn(['balances', 'availableBalance', 'amount']);

        dispatch(preSelectChangeSelectedAccount(accountId, accountBalance, fundId));
    }
};

const changeContract = (contractToChange) => (dispatch) => {
    dispatch(getIntervenersContractByContractNumber(contractToChange.contractNumber));
    dispatch(setContract(contractToChange));
}

/**
 * @param {string} customInstitutionSecurityId
 * @param {string|undefined} fundIdToPreSelect
 */
const operationStarted = (customInstitutionSecurityId, fundIdToPreSelect = '', isAlternativeFund = false) => (dispatch, getState) => {
    const fetchPurchasedFunds = dispatch(brokerMyInvestmentsActions.fetchMyInvestments()) || Promise.resolve();
    fetchPurchasedFunds
        .then(() => {
            if (isAlternativeFund) {
                dispatch(setIsAlternativeFund(true));
                return dispatch(searchFundByIsin(customInstitutionSecurityId));
            } else {
                dispatch(setIsAlternativeFund(false));
                return dispatch(getMorningStarScreener(customInstitutionSecurityId))
            }
        })
        .then(() => {
            if (fundIdToPreSelect) {
                dispatch(preSelectAccountOwningFund(fundIdToPreSelect));
            }
        })
};

const setIsAlternativeFund = (payload) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_IS_ALTERNATIVE_FUND,
    payload
});



const searchFundByIsin = (isin) => (dispatch, getState) => {
    const header = __CONTACT_CENTER__ ? {
        isOfficeAgent: isPrintOfficeMode() ? 'office' : 'CC'
    } : null;

    let requestData = {
        header: header,
        query: {
            text: isin,
            pageSize: 1,
            pageNumber: 1
        }
    };
    dispatch(requestInvestmentFundsInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('catalogueBrokerAdvancedSearch'), requestData)
        .then((data)=> {
            dispatch(requestInvestmentAlternativeFundsSuccess(data))
            fetchClosePrice(data.alternativeFunds.instrumentsList[0].isin, dispatch)
        })
        .then(() => {
            getAccountsAlternativeFunds(dispatch, getState);
        }
        , response => {
           dispatch(requestInvestmentFundsFailure(response.error))
        });
};

const setClosePrice = (response, isin) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_CLOSE_PRICE,
    payload: {response, isin},
});

const fetchClosePrice = (isin, dispatch) => {
    const requestData = {
        query: {
            isin: isin
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetClosePrice'), requestData)
    .then(
        response => {
            dispatch(setClosePrice(response, isin))
        }
    )
}

const validateFundDocumentsRequest = () => ({
    type: actionTypes.BROKER_HIRE_INVESTMENT_FUND_VALIDATE_DOCUMENTS_REQUEST
});

const validateFundDocumentsSuccess = enableEconomicReport => ({
    type: actionTypes.BROKER_HIRE_INVESTMENT_FUND_VALIDATE_DOCUMENTS_SUCCESS,
    payload: {
        enableEconomicReport
    }
});

const validateFundDocumentsFailure = () => ({
    type: actionTypes.BROKER_HIRE_INVESTMENT_FUND_VALIDATE_DOCUMENTS_FAILURE
});

const validateFundDocuments = (mustControlEconomicReport, history) => (dispatch, getState) => {
    const immInvestmentFunds = getState().investmentFunds;
    const isin = immInvestmentFunds.getIn(['investmentFunds', 'isin']);
    dispatch(validateFundDocumentsRequest());
    const immProfile = getState().profile;
    const immGlobalVariables = getState().globalVariables;
    const originCountry = immProfile.get('originCountry')
    const memories = immGlobalVariables.getIn(['variables', 'parameters', 'memories', 'memories']);
    let publicSiteUrl = apiURLBuilder.getPublicSiteUrl(false);
    if (!!publicSiteUrl && publicSiteUrl.slice(publicSiteUrl.length - 3, -2) === "/") {
        publicSiteUrl = publicSiteUrl.slice(0, -3);
    }
    const dfi = apiURLBuilder.getURL('morningstarFundDocumentPDF', {isin: isin, documentType: 'DFI', originCountry: originCountry})
    const mc = memories
        ? `${ publicSiteUrl}${memories.trim()}${isin}.pdf?originCountry=${originCountry}`
        : '';
    const mustShowMC = showMemories(originCountry , isin)
    if(!!dfi && (!mustShowMC || (!!mc )) ) {
        let arrayPromises = [APIGet(dispatch, dfi, {})];
        if (mustShowMC) {
            arrayPromises.push(APIGet(dispatch, mc, {}))
        }

        if (originCountry === PT) {
            const prospectus = apiURLBuilder.getURL('morningstarFundDocumentPDF', { isin: isin, documentType: 'Prospectus', originCountry: originCountry })
            const anual = apiURLBuilder.getURL('morningstarFundDocumentPDF', { isin: isin, documentType: 'Anual', originCountry: originCountry })
            arrayPromises.push(APIGet(dispatch, prospectus, {}))
            arrayPromises.push(APIGet(dispatch, anual, {}))
        }

        Promise.all(arrayPromises)
            .then(() => {
                const ies = apiURLBuilder.getURL('morningstarFundDocumentPDF', {isin: isin, documentType: 'InformeSemestral', originCountry: originCountry});
                return APIGet(dispatch, ies, {})
                    .then(() => {
                        dispatch(validateFundDocumentsSuccess(true));
                    }).catch(() => {
                        if (mustControlEconomicReport) {
                            dispatch(errorActions.show('', true, history));
                            dispatch(validateFundDocumentsFailure());
                        } else {
                            dispatch(validateFundDocumentsSuccess(false));
                        }
                    })
            }).catch(() => {
                dispatch(errorActions.show('', true, history));
                dispatch(validateFundDocumentsFailure());
            })
    } else {
        dispatch(errorActions.show('', true, history));
        dispatch(validateFundDocumentsFailure());
    }
};

const validateEconomicReport = (history) => (dispatch, getState) => {
    const typeId = BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER;
    const immInvestmentFunds = getState().investmentFunds;
    const requestData = {
            query: {
                viewId: 'fullNew',
                responseViewFormat: 'json'
            }
    }

    const secId = !!immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds'])
        ? immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'secId'])
        : null;

        dispatch(validateFundDocumentsRequest());


    return APIGet(
            dispatch,
            apiURLBuilder.getURL(
                'brokerGetMorningStarScreenerSecurityDetails',
                {
                    type: typeId,
                    id: secId,
                }
            ),
            requestData
        )
        .then((response) => {
            const mustControlEconomicReport =
                !!response[0] && !!response[0].InceptionDate
                    ? moment(response[0].InceptionDate).isBefore(moment().subtract(1, 'year'))
                    : false;
            dispatch(validateFundDocuments(mustControlEconomicReport, history));
        }).catch(() => {
            dispatch(errorActions.show('', true, history));
            dispatch(validateFundDocumentsFailure());
        });
}

const onClickStartWelcome = (status) => (dispatch) => {
    dispatch(setShowWelcome(status));
}

const setShowWelcome = status => ({
    type: actionTypes.FETCH_BROKER_INVESTMENT_ALTERNATIVE_FUNDS_SET_SHOW_WELCOME,
    payload: status
});

module.exports = {
    operationStarted,
    getMorningStarScreener,
    addIntervener,
    removeIntervener,
    restoreDefaultInterveners,
    reset,
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    setAmount,
    setAccountNumber,
    setIntervenerName,
    setIntervenerType,
    validateStep,
    changeAuth,
    changeReadChecked,
    setIsSubscription,
    postPreHire,
    getAccounts,
    hireInvestment,
    getSubscriptionDetails,
    addSubscription,
    getInterveners,
    resetFetchedPre,
    changeSelectedAccount,
    requestInvestmentFundsSuccess,
    getAccountSuccess,
    changeContract,
    getIntervenersContractByContractNumber,
    changeToNewContract,
    changeToSubscription,
    validateSchema,
    postExtantCostsBuyFunds,
    validateFundDocuments,
    validateEconomicReport,
    onClickStartWelcome,
};
